






































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { AddDeparment } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { enterpriseService } from '@/shared';
import { Utils } from '@/helper/utils';
import { IDialogOption } from '@/models/dialog';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})

export default class DepartmentAddPage extends Base {
  public form: any = {};
  public deparmentSetupFields: Array<VFields<any>> = [
    {
      key: 'name',
      type: 'v-alynk-text-field',
      required: true,
      templateOptions: {
        label: "Name",
        required: true,
        disabled: false,
        loading: false,
        rules: [
          v => this.required('Name', v)
        ]
      },
    },
    {
      key: 'description',
      type: 'v-alynk-text-field',
      required: true,
      templateOptions: {
        label: "Description",
        required: true,
        disabled: false,
        loading: false,
        rules: [
          v => this.required('Deparment Description', v)
        ]
      },
    },
  ];


  public deparmentAddModel: AddDeparment = {
    enterPriseId: 0,
    name: "",
    description: ""
  };
  public requestProgress: boolean = false;
  public buttons: any = [];
  public loading: boolean = false;
  public enterpriseId: number = 0;
  public departmentNameToDelete: string = "";
  public headers: VHeaders[] = [];
  public actions: any[] = [];
  public departmentItems: any = [];
  public paginations = new PaginationModel('name', true, 5);

  public setActions() {
    this.actions = [
    {
      type: 'button',
      icon: 'fas fa-trash-alt',
      title: "Delete",
      color: 'error',
      visible: (model: any) => true,
      action: (model: any) => {
        this.confirmDelete(model);
      },
    }
  ];
  }

  public setHeaders() {
    this.headers = [
      {
        align: 'left',
        sortable: true,
        text: "Name",
        value: 'name',
      },
      {
        align: 'left',
        sortable: true,
        text: "Description",
        value: 'description',
      },
      {
        align: 'center',
        text: "Actions",
        isNotDataProp: true,
        sortable: false,
      },
    ];
  }

  public removeDeparmentDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
    },
    onAction: (): void => {
      this.deleteDeparment();
    },
  };



  public mounted() {
    this.enterpriseId = Number(this.$route.params.id);
    this.buttons = [
      {
        id: '0',
        type: 'button',
        title: 'Back',
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('enterprise.backButton'),
        click: 'backToList',
        icon: 'fas fa-arrow-circle-left',
      },
    ];
    this.$emit('updateToolBar', this.buttons);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.GetEnterprisesDepartment();
    this.setHeaders();
    this.setActions();
  }
  public async GetEnterprisesDepartment(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.deparmentSetupFields);
     this.loading = true;
      const response = await enterpriseService.getEnterprisesDepartment(this.enterpriseId);
      this.departmentItems = response.departments;
      this.paginations.totalItems =  response.departments.length;
    } finally {
      this.loading = false;
      this.formlyHideSkeleton(this.deparmentSetupFields);
    }
  }

  public validateTrunkDetails(): Vue & { validate: () => boolean } {
    return this.$refs.DeparmentAddForm as Vue & { validate: () => boolean };
  }

  public async addDeparmentSetup(): Promise<void> {
    if (this.validateTrunkDetails().validate()) {
      try {
        this.requestProgress = true;
        this.deparmentAddModel.enterPriseId = this.enterpriseId,
        await enterpriseService.addEnterpriseDepartment(this.deparmentAddModel);
        this.showAlert(true, 'Deparment added successfully');
      } finally {
        this.requestProgress = false;
        this.deparmentAddModel.enterPriseId = 0;
        this.deparmentAddModel.name = "";
        this.deparmentAddModel.description = "";
        this.GetEnterprisesDepartment();
      }
    }
  }

  public async callMethod(methodName): Promise<void> {
    if (methodName === 'backToList') {
      this.$router.push({ name: 'admin.enterprises' });
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }


  public confirmDelete(model) {
    this.departmentNameToDelete = model.name;
    this.removeDeparmentDialog.model = true;
  }

  public async deleteDeparment(): Promise<void> {
    try {
      this.removeDeparmentDialog.loading = true;
      await enterpriseService.deleteEnterpriseDepartment(this.enterpriseId, this.departmentNameToDelete);
      this.showAlert(true, "Deparment deleted successfully");
    } finally {
      this.removeDeparmentDialog.loading = false;
      this.removeDeparmentDialog.model = false;
      this.GetEnterprisesDepartment();
    }
  }

  public updatePaging(paging: any) {
    this.paginations = paging;
  }

}
